import { render, staticRenderFns } from "./agent_status_icon.vue?vue&type=template&id=70024637"
import script from "./agent_status_icon.vue?vue&type=script&lang=js"
export * from "./agent_status_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports